import { PlusIcon } from '@radix-ui/react-icons';
import {
  ColumnDef,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { FC, useMemo } from 'react';

import { Alert } from 'components/ui/alert';
import { Button } from 'components/ui/button';
import { DataTable } from 'components/ui/data-table';
import { useModal } from 'hooks/useModal';
import { usePageCarto } from 'hooks/usePageCarto';
import { PageCartoDataForm } from './PageCartoDataForm';

export const PageCartoDataPanel: FC = () => {
  const { showModal, hideModal } = useModal();
  const { pageCartoId, columns: dataGridRows } = usePageCarto();
  const columns = useMemo<ColumnDef<(typeof dataGridRows)[number]>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Colonne',
      },
      {
        accessorKey: 'sample',
        header: 'Échantillon',
      },
      {
        accessorKey: 'source',
        header: 'Source',
      },
      {
        accessorKey: 'validity',
        header: 'Validité',
      },
      {
        accessorKey: 'dataset',
        header: 'Jeu de données',
      },
    ],
    []
  );

  const table = useReactTable({
    data: dataGridRows,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div>
      <div className="mt-5 text-right">
        <Button
          icon={PlusIcon}
          data-testid="import-dataset"
          onClick={() =>
            showModal({
              title: 'Importer un jeu de données',
              Component: PageCartoDataForm,
              props: { pageCartoId, onSubmit: hideModal },
            })
          }
        >
          Importer un jeu de données
        </Button>
      </div>
      <div className="my-2">
        {dataGridRows.length === 0 ? (
          <Alert variant="info">{`Aucun jeu de donnée n'a a été importé`}</Alert>
        ) : (
          <DataTable
            table={table}
            className="w-full max-h-96 overflow-y-auto"
          />
        )}
      </div>
    </div>
  );
};
